import {useEffect, useState} from "react";

type DeviceType = {
	isTouchDevice: boolean
	isTouchLaptop: boolean
	isTablet: boolean
	isDesktop: boolean
}

function getDeviceType(): DeviceType {
	const coarsePointer = window.matchMedia("(pointer: coarse)").matches
	const hasTouchPoints = navigator.maxTouchPoints > 0
	const isTouchDevice = hasTouchPoints || coarsePointer
	const isTablet = coarsePointer
	const isTouchLaptop = hasTouchPoints && !coarsePointer
	const isDesktop = !isTouchDevice
	return {isTouchDevice, isTouchLaptop, isTablet, isDesktop}
}

export function useDeviceType(): DeviceType {
	const [deviceType, setDeviceType] = useState<DeviceType>(getDeviceType)

	useEffect(() => {
		const pointerMq = window.matchMedia("(pointer: coarse)")
		const handleChange = () => setDeviceType(getDeviceType())
		let resizeTimer: ReturnType<typeof setTimeout>
		const handleResize = () => {
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(handleChange, 100)
		}

		pointerMq.addEventListener("change", handleChange)
		window.addEventListener("resize", handleResize)

		return () => {
			clearTimeout(resizeTimer)
			pointerMq.removeEventListener("change", handleChange)
			window.removeEventListener("resize", handleResize)
		}
	}, [])

	return deviceType
}
